// What a callout calls a structure (spec §10): at most 40 characters (`hud.label.max-chars`). The
// inspector, search and Methods keep the full name.
//
// In order, the first that has one:
// 1. the pack's own `short_name` (asset-pack contract). Since #618 the label-bearing packs carry
//    design's table (`design/short-names/`) as theirs: v0 0.1.2, ixi-165-v0 0.1.3, the head and the
//    three HD cortices, whose `dkt` layers carry it too;
// 2. the shown brain's label layer, for a structure its pack doesn't name (`ShownBrain.short`);
// 3. the name, cut to 40 characters.

export const MAX_CHARS = 40;

export const cut = (name: string) => (name.length > MAX_CHARS ? `${name.slice(0, MAX_CHARS - 1).trimEnd()}…` : name);

export function calloutName(s: { id: string; name: string; short_name?: string }, layerShort?: Readonly<Record<string, string>>): string {
  return cut(s.short_name ?? layerShort?.[s.id] ?? s.name);
}
